import React from 'react'
import PropTypes from 'prop-types'
import { FormSelectView } from '../FormFields/FormSelect/FormSelect.view.jsx'

/**
 * PlaceSelect View Component
 * Pure presentation - renders FormSelectView (react-select under the hood)
 * with server-side search semantics (filter disabled).
 */
export const PlaceSelectView = ({
  reactSelectOptions,
  reactSelectValue,
  isLoading,
  onChange,
  onInputChange,
  onMenuOpen,
  onMenuClose,
  inputValue,
  controlShouldRenderValue,
  onBlur,
  name,
  selectRef,
  required,
  index,
  error,
  errorMessage,
}) => {
  return (
    <FormSelectView
      label='Stop Address'
      placeholder='Type to search existing places'
      search
      clearable
      loading={isLoading}
      required={required}
      name={name}
      selectRef={selectRef}
      onBlur={onBlur}
      onChange={onChange}
      onInputChange={onInputChange}
      onMenuOpen={onMenuOpen}
      onMenuClose={onMenuClose}
      inputValue={inputValue}
      controlShouldRenderValue={controlShouldRenderValue}
      reactSelectOptions={reactSelectOptions}
      reactSelectValue={reactSelectValue}
      filterOption={() => true}
      error={error}
      errorMessage={errorMessage}
      data-testid={`stop-address-${index}`}
      data-automation-id={`stop-address-${index}`}
    />
  )
}

PlaceSelectView.propTypes = {
  reactSelectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  reactSelectValue: PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string,
  }),
  isLoading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
  inputValue: PropTypes.string,
  controlShouldRenderValue: PropTypes.bool,
  onBlur: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  selectRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  required: PropTypes.bool,
  index: PropTypes.number,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
}
